import { Role } from '@/api/types'

export default [
    {
        name: 'orders',
        path: '/orders',
        redirect: { name: 'orders_all' },
        meta: {
            requiredRole: Role.EMPLOYEE,
        },
        component: () => import(/* webpackChunkName: "orders" */ '../../views/Orders/Orders.vue'),
        children: [
            {
                name: 'orders_all',
                path: '/orders/all',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                component: () => import(/* webpackChunkName: "orders_list" */ '../../views/Orders/List.vue'),
            },
            {
                name: 'orders_detail',
                path: '/orders/:orderId',
                props: true,
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                redirect: { name: 'orders_detail_financial' },
                component: () => import(/* webpackChunkName: "orders_detail" */ '../../views/Orders/Detail.vue'),
                children: [
                    {
                        name: 'orders_detail_future_address',
                        path: '/orders/:orderId/future_address',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "orders_detail_future_address" */ '../../views/Orders/Detail/OrderDetails/FutureAddress.vue'),
                    },
                    {
                        name: 'orders_detail_financial',
                        path: '/orders/:orderId/financial',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "orders_detail_financial" */ '../../views/Orders/Detail/OrderDetails/Financial.vue'),
                    },
                    {
                        name: 'orders_detail_files',
                        path: '/orders/:orderId/files',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "orders_detail_files" */ '../../views/Orders/Detail/OrderDetails/Files.vue'),
                    },
                ],
            },
        ],
    },
]
